/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type GenerateLineupsForGreenMachineSessionInput = {|
  greenMachineSessionId: string,
  regenerateFromLineupSetId?: ?string,
  clientMutationId?: ?string,
|};
export type GenerateLineupsMutationVariables = {|
  input: GenerateLineupsForGreenMachineSessionInput
|};
export type GenerateLineupsMutationResponse = {|
  +generateLineupsForGreenMachineSession: ?{|
    +success: ?boolean
  |}
|};
export type GenerateLineupsMutation = {|
  variables: GenerateLineupsMutationVariables,
  response: GenerateLineupsMutationResponse,
|};
*/


/*
mutation GenerateLineupsMutation(
  $input: GenerateLineupsForGreenMachineSessionInput!
) {
  generateLineupsForGreenMachineSession(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GenerateLineupsForGreenMachineSessionPayload",
    "kind": "LinkedField",
    "name": "generateLineupsForGreenMachineSession",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GenerateLineupsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GenerateLineupsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e036c611d0b37c4d6c84afd1e0bbd8a5",
    "id": null,
    "metadata": {},
    "name": "GenerateLineupsMutation",
    "operationKind": "mutation",
    "text": "mutation GenerateLineupsMutation(\n  $input: GenerateLineupsForGreenMachineSessionInput!\n) {\n  generateLineupsForGreenMachineSession(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '61bb6ac494c168d97ec114ea76a372ee';

module.exports = node;
